<template>
  <div class="globalHeader">
    <div class="head-hall">
      {{ hallInfo && hallInfo.departName ? hallInfo.departName : '' }}
    </div>
    <ul class="head-menu">
      <li v-for="(item, index) in menu" :key="index" @click="goPage(item)">
        {{ item.label }}
      </li>
    </ul>
    <div class="head-action">      
      <span class="action" @click="goSystem">切换系统</span>
      <el-button type="primary" size="small" @click="toPage">智能导办系统</el-button>
      <i class="el-icon-message-solid" style="margin:0 10px;font-size:20px"></i>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="head-img">
            <img :src="userInfo.avatar" alt="">
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-s-tools" command="0">个人设置</el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-goods" command="1">我的收藏</el-dropdown-item>
          <el-dropdown-item icon="el-icon-error" command="2">我的纠错</el-dropdown-item>
          <el-dropdown-item icon="el-icon-circle-plus" command="3">我的添加</el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-unfold" command="e">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {listByUser} from '@/api/login'
import { getFrontConfig, utils } from 'ow-service-component'
import { ACCESS_TOKEN, ACCESS_SECRET } from "@/store/mutation-types"
import Vue from 'vue'
export default {
  name: 'GlobalHeader',
  components: {
  },
  data () {
    return {
      menuList: {
        projectName: '宜城市政务服务中心政务中枢',
        menu: {
          home: {
            label: '主页',
            type: 'homePage',
            // page: [
            //   {
            //     label: '首页',
            //     path: '/home'
            //   },
            //   {
            //     label: 'OA中心'
            //   },
            //   {
            //     label: '培训中心'
            //   },
            //   {
            //     label: '业务中心'
            //   },
            //   {
            //     label: '指挥中心'
            //   }
            // ]
          }
        }
      },   
      visible: false,
    }
  },
  computed: {
    ...mapState(["user"]),
    userInfo () {
      console.log(this.user)
      return this.user.info
    },
    hallInfo () {
      return this.user.hallInfo
    },
    menu () {
      return this.menuList.menu.home.page
    }
  },
  methods: {
    ...mapActions(['Logout']),
    goSystem () {
      console.log(getFrontConfig())
      if (getFrontConfig().SSO_URL) {
        window.open(getFrontConfig().SSO_URL, '_blank')
      } else {
        this.$message.warning('查询不到对应的参数')
      }
    },
    goOuterPage(item) {
      console.log(item.url)
      if (item.url) {
        if (item.queryArgs) {
          let params = (eval("(" + item.queryArgs + ")") || {})
          for (let param in params) {
            if (params[param].startsWith('this.')) {
              try {
                params[param] = eval(params[param]) || ''
              } catch (err) {
                params[param] = ''
              }
            }
          }
          let queryStr = utils.axiosUtils.genQuery(params)
          console.log(queryStr)
          window.open(`${item.url}?${queryStr}`, '_blank')
        }
        else {
          window.open(`${item.url}`, '_blank')
        }
      }
      else {
        this.$message.warning('查询不到对应的参数')
      }
      this.visible = false
    },
    toPage () {
      window.history.pushState(null, '', '/subApplication/GovernmentGuideWeb')
    },
    handleCommand (command) {
      if (command == 'e') {
        let systemName = 'MAIN_CENTER_URL'
        const redirectUrl = getFrontConfig()['sso-config'][systemName] =''
        if (redirectUrl && getFrontConfig().SSO_URL) {
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove(ACCESS_SECRET)
          // 认证中心地址
          window.location.href =`${getFrontConfig().SSO_URL}login?redirect=logout`
        }
        else {
          this.Logout().then(res => {
            this.$router.push({
              path: '/login'
            })
            // window.history.pushState(null, '', `${__webpack_public_path__}login`)
            console.log(res)
          }).catch(err => {
            console.log(err)
          })
        }
      } else {
        this.$router.push({
          path: '/MyCenter',
          query: { menuIdx: command }
        })
      }
    },
    goPage(item) {
      item.path ? this.$router.push(item.path) : ''
    }
  }

}
</script>

<style lang="less" scoped>
.globalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #F7F8FA;
}

.head-hall {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.head-menu {
  display: flex;
  list-style: none;
  flex: 1;

  li {
    margin-left: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #111111;
    cursor: pointer;
  }
}

.head-action {
  display: flex;
  align-items: center;

  .head-img {
    width: 28px;
    height: 28px;
    border-radius: 50%;

    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .action {
    font-size: 14px;
    color: #606266;
    margin: 0 12px;
    &:hover {
      color: #4677ee;
    }
  }
}
.change-system {
    font-size: 14px;
    margin-right: 10px;
    .el-button {
      border: none;
      font-size: 14px;
      color: #000;
      padding: 12px;
      background: transparent;
      &:hover{
        background: transparent;
        color: #4677ee;
      }
    }
  }
</style>
<style lang="less">
	.change-system-list {
  font-size: 14px;
  line-height: 28px;
  padding: 0 10px;
  cursor: pointer;
  &:hover {
    background-color: #4677ee;
    color: white;
  }
}
</style>